/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTimelineLogDtoBase
 * auto generated base class for the model RouteTimelineLogDtoModel.
 */
export const RouteTimelineLogDtoModelBase = ModelBase
  .named('RouteTimelineLogDto')
  .props({
    __typename: types.optional(types.literal("RouteTimelineLogDto"), "RouteTimelineLogDto"),
    id: types.identifier,
    eventUuid: types.union(types.undefined, types.string),
    date: types.union(types.undefined, types.string),
    status: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, types.null, types.string),
    notes: types.union(types.undefined, types.null, types.string),
    signature: types.union(types.undefined, types.null, types.string),
    photoUrl: types.union(types.undefined, types.null, types.string),
    outOfSequence: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTimelineLogDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
  get date() { return this.__attr(`date`) }
  get status() { return this.__attr(`status`) }
  get reason() { return this.__attr(`reason`) }
  get notes() { return this.__attr(`notes`) }
  get signature() { return this.__attr(`signature`) }
  get photoUrl() { return this.__attr(`photoUrl`) }
  get outOfSequence() { return this.__attr(`outOfSequence`) }
}
export function selectFromRouteTimelineLogDto() {
  return new RouteTimelineLogDtoModelSelector()
}

export const routeTimelineLogDtoModelPrimitives = selectFromRouteTimelineLogDto().eventUuid.date.status.reason.notes.signature.photoUrl.outOfSequence
